import { useCallback, useEffect, useState } from "react"
import { useAuthContext } from "../../../auth/useAuthContext"
import useUser from "../../../hooks/api/useUser"
import { useSnackbar } from '../../../components/snackbar';
import { useNavigate } from "react-router";
import { PATH_DASHBOARD } from "../../../routes/paths";
import useRole from "../../../hooks/api/useRole";
import useTableSettings from "../../../hooks/useTableSettings";
import { onGetCatalogs } from "../../../utils/forms";

const useUserListPage = () => {

    const {user} = useAuthContext()
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();


    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const [error, setError] = useState(false)
    const [users, setUsers] = useState([])
    const [roles, setRoles] = useState([])
    const [count, setCount] = useState(0)
    const [selected, setSelected] = useState()

   /* const [table_config, setTableConfig] = useState({
        order_by:'id_user',
        order:1,
        limit:10, 
        offset:0,
    })*/

    const [modals, setModals] = useState({
        add_user:false,
        delete_user:false
    })

    const tableController = useTableSettings({
        initial_filter:{
            search:{key:'id_order', value:'', operator:'LIKE'},
            role:{key:'main_role_id', value:-1, operator:'='}
            //start_date:{key:'', value:'', operator:'>='},
            //end_date:{key:'', value:'', operator:'<='}
        },
        initial_params:{
            order_by:'id_user',
            order:1,
            limit:25, 
            offset:0
        }
    })


    const userManager = useUser()
    const roleManager = useRole()

    useEffect(() => {
        actions.onInitModule()
    }, [])

    useEffect(() => {
        if(roles) actions.onRefreshData()
    },[tableController.pagination, tableController.filter, roles])

    const onGetParams = useCallback(() => {
        const {pagination} = tableController
        let result = {...pagination}
        result.offset = pagination.limit*pagination.offset
        let ANDargs = []
        Object.keys(tableController.filter).forEach(key => {
            const item = tableController.filter[key]
            if(item.value && item.value !== -1){
                if(key === 'search'){
                    
                    ANDargs.push({
                        "OR":[
                            {field:'first_name', operator:item.operator, value:`%${item.value}%`},
                            {field:'fathers_last_name', operator:item.operator, value:`%${item.value}%`},
                            {field:'email', operator:item.operator, value:`%${item.value}%`}
                        ]
                    })
                }else{
                    ANDargs.push({field:item.key, operator:item.operator, value:item.value})
                }
            }else{
                if(key === "role" && roles.length){
                    let ortemp = []
                    roles.forEach(item => {
                        ortemp.push(
                            {field:'main_role_id', operator:"=", value:item.value}
                        )
                    })
                    ANDargs.push({"OR":ortemp})
                    
                }

                
            }
        
        })
        if(ANDargs.length){
            const temp = `${JSON.stringify({"AND":ANDargs})}`
            //console.log(JSON.parse(temp))
            result.filter = temp
        }
        return result
    },[tableController.pagination, tableController.filter, roles])

    const actions = {
        onInitModule: async() => {
            setLoading(true)
            try {
                const role_params = {order_by:'name', order:0}
                const _roles = await roleManager.actions.onGetAll(role_params)

                let _newdata = _roles.data.filter(el => el.name.toLowerCase().includes("doctor") /*|| el.name.toLowerCase().includes("pharmacy")*/)
                setRoles(onGetCatalogs(_newdata,'id_role', 'name'))
            } catch (error) {
                setError(error)
                enqueueSnackbar(error?.message, {variant:"error"})
            }
            setLoading(false)
        },
        onRefreshData: async() => {
            setSending(true)
            try {
                const params = onGetParams()
                const _users = await userManager.actions.onGetAll(params)
                setUsers(_users.data)
                setCount(_users.count)
            } catch (error) {
                setError(error)
                enqueueSnackbar(error?.message, {variant:"error"})
            }
            setSending(false)
            
        },
        onRequestSearch: (value) => {
            console.log(value)
            tableController.onUpdatePaginationValue('offset', 0)
            tableController.onUpdateFilterValue('search', value)
        },
        onSelectRow: (row) => {
            //console.log(row)
            const userid = row?.user_id || row?.id_user
            navigate(PATH_DASHBOARD.doctor.account(userid))
        },
        onEditRow: (row) => {
            setSelected(row)
            actions.onChangeModalStatus('edit_user', true)
        },
        onDeleteRow: async(row) => {
            console.log('Eliminar', row)
            actions.onChangeModalStatus('delete_user', false)
            setLoading(true)
            try {
                actions.onChangeModalStatus('delete_user', false)
                await userManager.actions.onDelete(row.id_user)
                await actions.onRefreshData()
                enqueueSnackbar('Usuario eliminado exitosamente', {variant:"success"})
            } catch (error) {
                console.log(error)
                setError(error)
                enqueueSnackbar(error?.message, {variant:"error"})
            }
            setLoading(false)
        },
        onChangeModalStatus: (key, status) => {
            let _modals = {...modals}
            _modals[key] = status
            setModals(_modals)
        }, 
        onSelectedRow: (_data) => {
            setSelected(_data)
        },
        onChangePagination: (_data) =>{
            tableController.setPagination(_data)
        }
    }

    
    const table_config = tableController.pagination

    const system = {loading, sending, error}
    const data = {users, user, table_config, count, selected, roles}

    return {
        system, data, actions, modals, tableController
    }
}
 
export default useUserListPage;